import React, { useEffect } from 'react';
import EditHoldReport from '../EditHoldReport/EditHoldReport';
import { ButtonBase } from '@mui/material';
import playIcon from '../../assets/Icons/Play.svg';
import noImageFound from '../../assets/Icons/noImageFound.svg';

const ViewHoldReport = ({ refreshDataHandler, data }) => {
  useEffect(() => {
    console.log('data', data);
  }, [data]);
  const [open, setOpen] = React.useState(false);
  const handleOpen = (data) => {
    console.log('data', data);
    setModalData(data);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    refreshDataHandler();
  };
  const [modalData, setModalData] = React.useState(null);
  return (
    <>
      {data.map((item, index) => {
        console.log('HoldReportSectionV2', item);
        return (
          <>
            {item.edited && (
              <div className='flex justify-start'>
                <div className='bg-[#F3F3F3] rounded-t-[4px] px-5 text-[#7C7C7C] text-xs leading-4 font-semibold py-1'>
                  Edited
                </div>
              </div>
            )}
            <table className='bg-[#F5F9FF] overflow-hidden rounded-[10px] w-full font-rubik mb-6 print:break-inside-avoid-page'>
              <thead>
                <tr className='bg-[#2F2E41] text-[#FFFFFF] text-base leading-5 font-normal py-4'>
                  <th className='rounded-tl-[6px] rounded-bl-[6px] py-4 font-normal'>
                    Thumbnails
                  </th>
                  <th className='py-4 font-normal pl-8'>Measured Time</th>
                  <th className='py-4 font-normal'>
                    Improvement Opportunity Level
                  </th>
                  <th className='py-4 font-normal'>Remark</th>
                  <th className='py-4 font-normal'>Reason</th>
                  <th className='rounded-tr-[6px] rounded-br-[6px] font-normal'>
                    {' '}
                    Legend(Sec)
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className='text-left pb-6 pl-8'>
                    <div className='mb-4 mt-3 text-[#3F3D56] text-[14px] leading-5 font-normal'>
                      {item.assessment_name.toUpperCase()}
                    </div>
                    {item.assessment_output.start_position_url ? (
                      <img
                        className='w-[156px] h-[104px] rounded-[10px]'
                        src={item.assessment_output.start_position_url}
                        alt=''
                      />
                    ) : (
                      <div className='w-[156px] h-[104px] rounded-[10px] bg-[#ebeff5] flex justify-center items-center flex-col gap-2'>
                        <img src={noImageFound} alt='' width={30} height={30} />
                        <div className='text-[#6A6A6A] text-sm opacity-70'>
                          Preview not Available
                        </div>
                      </div>
                    )}
                    <ButtonBase
                      sx={{
                        backgroundColor: '#788CFC',
                        color: '#fff',
                        width: '156px',
                        borderRadius: '5px',
                        padding: '8px 0',
                        marginTop: '12px',
                        fontSize: '12px',
                      }}
                      onClick={() => {
                        handleOpen(item);
                      }}
                    >
                      <img
                        src={playIcon}
                        className='w-[15px] h-[15px] mr-[10px]'
                        alt=''
                      />
                      View & Edit
                    </ButtonBase>
                  </td>
                  <td className='text-center pb-6 text-[#3F3D56] text-[14px] leading-4 font-normal pl-8'>
                    <div>
                      {item.assessment_output.value}{' '}
                      {item.assessment_output.value === 'NA' ? '' : 'sec'}
                    </div>
                  </td>
                  <td className='text-center pb-6 w-[172px]'>
                    <div
                      className='rounded-sm text-sm py-2 px-7 font-medium w-fit mx-auto my-0'
                      style={{
                        backgroundColor:
                          item.interpretation_config.background_color_code,
                        color: item.interpretation_config.font_color_code,
                      }}
                    >
                      {item.interpretation_config.interpretation}
                      {item.edited ? '*' : ''}
                    </div>
                  </td>
                  <td className='text-center pb-6 pl-3 w-[112px]'>
                    {item.remarks ? item.remarks : 'NA'}
                  </td>
                  <td className='text-center pb-6 pt-7 pl-7'>
                    {item.assessment_output.end_position_url ? (
                      <img
                        className='w-[156px] h-[104px] rounded-[10px] mx-auto my-0'
                        src={item.assessment_output.end_position_url}
                        alt=''
                      />
                    ) : (
                      <div className='w-[156px] h-[104px] rounded-[10px] mx-auto my-0 bg-[#ebeff5] flex justify-center items-center flex-col gap-2'>
                        <img src={noImageFound} alt='' width={30} height={30} />
                        <div className='text-[#6A6A6A] text-sm opacity-70'>
                          Preview not Available
                        </div>
                      </div>
                    )}
                    <div className='mb-4 mt-3 text-[#3F3D56] text-[14px] leading-5 font-normal'>
                      {item.assessment_output.compensating_part}
                    </div>
                  </td>
                  <td className='text-center pb-6 pt-9 w-1/5 pl-7'>
                    <table className='my-0 mx-auto border-separate border-spacing-y-[20px]'>
                      <tbody>
                        {item.legends.map((legend) => {
                          return (
                            <tr className='flex items-center pb-5 pr-3'>
                              <td
                                className='w-4 h-3 rounded-sm flex-shrink-0 flex-grow-0'
                                style={{
                                  backgroundColor: legend.color_code,
                                }}
                              ></td>
                              <td className='text-[#3F3D56] text-[14px] leading-4 font-normal text-left pl-5'>
                                {legend.legend}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </>
        );
      })}
      {open && (
        <EditHoldReport
          modalData={modalData}
          open={open}
          handleClose={handleClose}
          handleOpen={handleOpen}
        />
      )}
    </>
  );
};

export default ViewHoldReport;
